import React from 'react';
import { cn } from '../../lib/utils';
export function Card({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('bg-navy-700 border border-navy-600 p-6 md:p-8 relative group hover:border-gold-500/50 transition-colors duration-300', className)} {...props} data-id="element-371">
      {/* Corner accents */}
      <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-gold-500/30 group-hover:border-gold-500 transition-colors" data-id="element-372"></div>
      <div className="absolute top-0 right-0 w-2 h-2 border-t border-r border-gold-500/30 group-hover:border-gold-500 transition-colors" data-id="element-373"></div>
      <div className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-gold-500/30 group-hover:border-gold-500 transition-colors" data-id="element-374"></div>
      <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-gold-500/30 group-hover:border-gold-500 transition-colors" data-id="element-375"></div>

      {children}
    </div>;
}